import { ContractOrProduct } from '../../payment-information';
import { PricingInformation } from '../../pricing-information';

export interface ContractOrProductWithPrice extends ContractOrProduct {
  pricingInformation: PricingInformation;
}
